import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-arm-details-view',
  templateUrl: './arm-details-view.component.html',
  styleUrls: ['./arm-details-view.component.css']
})
export class ArmDetailsViewComponent implements OnInit {

  title="Arms Detail";
  
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/arm-details/arm-details-view/arm-details-view.component.ts